import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const bandra: AreaConfig = {
  name: 'Bandra',
  slug: 'bandra',
  tagline: 'Doorstep Mobile Repair in Bandra, Mumbai',
  description:
    "Get your phone repaired without leaving Bandra. Minto's certified technician comes to your home, café, or office in Bandra West or East and fixes your device in under an hour.",
  localities: [
    'Bandra West', 'Bandra East', 'Khar West', 'Khar East', 'Santacruz West',
    'Carter Road', 'Linking Road', 'Hill Road', 'Band Stand', 'Pali Hill',
    'Mount Mary', 'Reclamation', 'BKC', 'Kalanagar', 'Turner Road',
  ],
  zones: [
    {
      name: 'Bandra West — Carter Road & Linking Road',
      line: 'Western Line',
      station: 'Bandra West Station',
      localities: ['Carter Road', 'Linking Road', 'Hill Road', 'Band Stand', 'Pali Hill', 'Mount Mary', 'St. Andrews Road', 'Chapel Road', 'Perry Cross Road'],
      desc: "Bandra's premium residential lanes covered. Whether you're at a café on Linking Road or home near Band Stand, our technician reaches you in 45–60 minutes.",
    },
    {
      name: 'BKC & Bandra East',
      line: 'Western Line',
      station: 'Bandra East Station / BKC',
      localities: ['BKC', 'Bandra Kurla Complex', 'Kalanagar', 'Bandra East', 'Dharavi Road', 'Reclamation'],
      desc: 'Corporate offices in BKC and residential areas of Bandra East fully covered. We visit your office desk and complete the repair without interrupting your workday.',
    },
    {
      name: 'Khar & Santacruz',
      line: 'Western Line',
      station: 'Khar Road Station / Santacruz Station',
      localities: ['Khar West', 'Khar East', 'Santacruz West', 'Santacruz East', 'Vakola', 'Milan Subway', 'Juhu Tara Road'],
      desc: 'Khar and Santacruz are within our Bandra service radius. Same doorstep service, same 90-day warranty.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Bandra | Doorstep Phone Repair Service | Minto',
    description:
      'Expert doorstep mobile repair in Bandra West, Bandra East & BKC, Mumbai. Screen replacement, battery repair, charging port fix. 90-day warranty. Starting ₹299. Book now!',
    keywords:
      'mobile repair Bandra, phone repair Bandra, screen repair Bandra West, battery replacement Bandra, doorstep mobile repair Bandra, iPhone repair Bandra, Samsung repair Bandra, BKC phone repair, Khar mobile repair, mobile repair Bandra East, Linking Road phone repair, Carter Road phone repair',
  },
  faqs: [
    {
      q: 'Do you offer mobile repair at home in Bandra West?',
      a: 'Yes, we cover all of Bandra West including Linking Road, Carter Road, Pali Hill, Band Stand, and Mount Mary. Book online and a technician will arrive in 60–90 minutes.',
    },
    {
      q: 'Can you repair my phone at my office in BKC?',
      a: 'Absolutely. We service BKC (Bandra Kurla Complex) and Kalanagar. Our technicians are comfortable visiting corporate offices.',
    },
    {
      q: 'How much does iPhone screen replacement cost in Bandra?',
      a: 'iPhone screen replacement starts from ₹2,499 depending on the model. Select your iPhone on the booking page for the exact price.',
    },
    {
      q: 'Do you also cover Khar and Santacruz near Bandra?',
      a: 'Yes, we cover Khar West, Khar East, and Santacruz West as part of our Bandra service zone.',
    },
    {
      q: 'What is the warranty on repairs in Bandra?',
      a: 'All repairs come with a 90-day warranty. Screen replacements carry a 90-day warranty and battery replacements carry a 6-month warranty on the part.',
    },
  ],
};

const BandraPage: React.FC = () => <AreaLandingPage area={bandra} />;
export default BandraPage;
